import React from 'react'
import {Icon} from '@chakra-ui/react'

const ExclamationIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <g clipPath="url(#clip0_315_1622)">
                <g clipPath="url(#clip1_315_1622)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20 28.4375C20.5091 28.4375 20.9219 28.0248 20.9219 27.5156C20.9219 27.0065 20.5091 26.5938 20 26.5938V25.4375C18.8523 25.4375 17.9219 26.3679 17.9219 27.5156C17.9219 28.6633 18.8523 29.5938 20 29.5938V28.4375Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20 25.4375C21.1477 25.4375 22.0781 26.3679 22.0781 27.5156C22.0781 28.6633 21.1477 29.5938 20 29.5938V28.4375C19.4909 28.4375 19.0781 28.0248 19.0781 27.5156C19.0781 27.0065 19.4909 26.5938 20 26.5938V25.4375Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M21.5 8.09375V23.8125H18.5V8.09375H21.5Z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.001 37.0833C29.4358 37.0833 37.0843 29.4349 37.0843 20C37.0843 10.5651 29.4358 2.91667 20.001 2.91667C10.5661 2.91667 2.91764 10.5651 2.91764 20C2.91764 29.4349 10.5661 37.0833 20.001 37.0833ZM20.001 40C31.0467 40 40.001 31.0457 40.001 20C40.001 8.9543 31.0467 0 20.001 0C8.95528 0 0.000976562 8.9543 0.000976562 20C0.000976562 31.0457 8.95528 40 20.001 40Z"
                        fill="currentColor"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_315_1622">
                    <rect
                        width="40"
                        height="40"
                        fill="white"
                        transform="translate(0 0.000244141)"
                    />
                </clipPath>
                <clipPath id="clip1_315_1622">
                    <rect width="40" height="40" fill="white" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default ExclamationIcon
